import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWerklijndiagram = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M15 11V14H3V11H15ZM15 10H3C2.45 10 2 10.45 2 11V14C2 14.55 2.45 15 3 15H15C15.55 15 16 14.55 16 14V11C16 10.45 15.55 10 15 10ZM20 17V20H10V17H20ZM20 16H10C9.45 16 9 16.45 9 17V20C9 20.55 9.45 21 10 21H20C20.55 21 21 20.55 21 20V17C21 16.45 20.55 16 20 16ZM7 17V20H3V17H7ZM7 16H3C2.45 16 2 16.45 2 17V20C2 20.55 2.45 21 3 21H7C7.55 21 8 20.55 8 20V17C8 16.45 7.55 16 7 16ZM20 5V8H8V5H20ZM20 4H8C7.45 4 7 4.45 7 5V8C7 8.55 7.45 9 8 9H20C20.55 9 21 8.55 21 8V5C21 4.45 20.55 4 20 4Z' />
  </svg>
);
export default SvgWerklijndiagram;
